import PropTypes from 'prop-types'

const UserIcon = ({ title }: any) => (
  <svg width={33} height={35} viewBox="0 0 33 35">
    <title>{title}</title>
    <g strokeWidth={3}>
      <path d="M16.5 18.9c4.576 0 8.286-3.9 8.286-8.709 0-4.81-2.203-8.708-8.286-8.708S8.214 5.382 8.214 10.19c0 4.81 3.71 8.708 8.286 8.708zM31 32.954c-3.543-4.706-7.547-7.285-14.862-7.285S4.887 29.344 2 33.985" />
    </g>
  </svg>
)

UserIcon.displayName = 'UserIcon'

UserIcon.propTypes = {
  title: PropTypes.string
}

UserIcon.defaultProps = {
  title: 'User'
}

export default UserIcon
